// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { CognitoJwtVerifier } from 'aws-jwt-verify';
import { isValidCognitoToken } from './isValidCognitoToken';
/**
 * Creates a validator object for validating methods in a KeyValueStorage.
 */
export const createTokenValidator = ({ userPoolId, userPoolClientId: clientId, }) => {
    let idTokenVerifier;
    let accessTokenVerifier;
    return {
        // validate access, id tokens
        getItem: async (key, value) => {
            const isAccessToken = key.includes('.accessToken');
            const isIdToken = key.includes('.idToken');
            if (!isAccessToken && !isIdToken) {
                return true;
            }
            if (!userPoolId || !clientId) {
                return false;
            }
            if (isAccessToken && !accessTokenVerifier) {
                accessTokenVerifier = CognitoJwtVerifier.create({
                    userPoolId,
                    tokenUse: 'access',
                    clientId,
                });
            }
            if (isIdToken && !idTokenVerifier) {
                idTokenVerifier = CognitoJwtVerifier.create({
                    userPoolId,
                    tokenUse: 'id',
                    clientId,
                });
            }
            return isValidCognitoToken({
                token: value,
                verifier: isAccessToken ? accessTokenVerifier : idTokenVerifier,
            });
        },
    };
};
